<template>
    <div class="py-4">
        <modal-filter :onfilter="onfilter" :filter="filter" @onclose="onfilter = false" @onfilter="ONFILTER()" :exclude="['state_id', 'payment_state_id']"/>
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Facturación</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                        <form class="d-flex gap-3 row" @submit.prevent="FILTER()">
                            <div>
                                <button @click="onfilter = true" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="bi bi-funnel me-2"></i>
                                    <span>Filtro</span>
                                    <span class="vr opacity-20 mx-3"></span>
                                    <span class="text-xs text-primary">{{ count_filter }}</span>
                                </button>
                            </div>
                            <div>
                                <button @click="SORT()" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="me-2" :class="filter.sortDesc == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                    <span>{{ filter.sortDesc }}</span>
                                </button>
                            </div>
                            <div class="col-md-4 px-0">
                                <div class="input-group input-group-sm input-group-inline">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text pe-2 text-sm"><i class="bi bi-search"></i></span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Buscar..." v-model="filter.search">
                                </div>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-h px-3 btn-primary">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'filter'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Buscar</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-h px-3 btn-danger" @click="CLEAR()">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'clear'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Limpiar</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <list-task :calculate="calculate" :confirm="confirm" :items="items" @options="GET_OPTIONS" @on_calculate="CALCULATE" @on_confirm="CONFIRM" @add_line="ADD_LINE" @remove_line="REMOVE_LINE" :loading="loading"/>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalFilter from './modals/Filter'
import listView from './table/list-view'
import listTask from './table/list-task'
export default {
    components: { ModalFilter, listView, listTask },
    data() {
        return {
            items: {
                data: [],
                total: 0,
                to: 0
            },
            options: {},
            loading: '',
            cancelToken: null,
            filter: {
                operator: 'LIKE',
                sortBy: 'id',
                sortDesc: 'ASC',
                fields: ['id', 'tracking', 'description'],
                search: '',
            },
            onfilter: false,
            option: Number(localStorage.getItem('option_billing') | 0),
            count: 0,
            calculate: [],
            confirm: [],
        }
    },
    computed: {
        count_filter: function(){
            let count = 0;
            let vue = this
            Object.entries(vue.filter).forEach((e) => {
                if(e[0] != 'sortBy' && e[0] != 'sortDesc' && e[0] != 'search'){
                    if(typeof e[1] == 'object'){
                        if(e[1]){
                            if(e[1].length > 0){
                                count++
                            }
                        }
                    }else{
                        if(e[1]){
                            count++
                        }
                    }   
                }
            })
            return count;
        }
    },
    methods: {
        OPTION_VIEW: function(){
            let vue = this
            vue.option = vue.option ? 0 : 1
            localStorage.setItem('option_billing', vue.option)
        },
        INIT: function () {
            let vue = this
            const source = axios.CancelToken.source()
            vue.cancelToken = source
            const { page, itemsPerPage } = vue.options
            let query = {
                page: page,
                itemsPerPage: itemsPerPage,
            }
            Object.entries(vue.filter).forEach((e) => {
                query[e[0]] = e[1]
            })
            axios({
                url: '/thinning',
                method: 'GET',
                params: query,
                cancelToken: source.token,
            })
                .then((resp) => {
                    vue.items = resp.data
                    vue.loading = ''
                })
                .catch((err) => {
                    if (err.code !== 'ERR_CANCELED') {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.loading = ''
                    }
                })
        },
        SORT: function () {
            let vue = this
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.filter.sortDesc = vue.filter.sortDesc == 'ASC' ? 'DESC' : 'ASC'
            vue.loading = 'sort'
            vue.INIT()
        },
        ONFILTER: function(){
            let vue = this
            vue.onfilter = false
            vue.loading = 'table'
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        FILTER: function () {
            let vue = this
            let count = 0
            if (vue.filter.search.length > 0) {
                count++
            }
            if (count > 0) {
                vue.loading = 'filter'
                if (vue.cancelToken) {
                    vue.cancelToken.cancel("Solicitud cancelada");
                }
                vue.INIT()
            }
        },
        CLEAR: function () {
            let vue = this
            vue.loading = 'clear'
            vue.filter = {
                operator: 'LIKE',
                sortBy: 'id',
                sortDesc: 'ASC',
                fields: ['id', 'tracking', 'description'],
                search: '',
            }
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        CALCULATE: function(item){
            let vue = this
            if(vue.calculate.filter(e => e == item.id).length == 0){
                vue.calculate.push(item.id)
                let data = {
                    package_id: item.id,
                    tax_id: item.tax_id,
                    value: item.value,
                    weight: item.weight,
                    user_id: item.user_id,
                    weight_type: 1,
                }
                axios({url: '/calculate', method: 'POST', data: data })
                .then((resp) => {
                    var audio = new Audio(soundSuccess)
                    audio.play()
                    Object.entries(resp.data).forEach((element) => {
                        if(element[0] == 'invoice_items'){
                            if(typeof item[element[0]] == 'undefined'){
                                item[element[0]] = []
                            }
                            item[element[0]] = element[1]
                        }else{
                            item[element[0]] = element[1]
                        }
                    });
                    let index = vue.items.data.findIndex(e => e.id == item.id)
                    vue.items.data.splice(index, 1, item)
                    let remove = vue.calculate.findIndex(e => e == item.id)
                    vue.calculate.splice(remove, 1)
                })
                .catch((err) => {
                    var audio = new Audio(soundError)
                    audio.play()
                    if(err.response.status !== 422){
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.errors = err.response.data
                    }
                    let index = vue.calculate.findIndex(e => e == item.id)
                    vue.calculate.splice(index, 1)
                })
            }
        },
        ADD_LINE: function(item){
            let vue = this
            if(typeof item.invoice_items == 'undefined'){
                item.invoice_items = []
            }
            item.invoice_items.push({ value: '', description: '', type: '' })
            let index = vue.items.data.findIndex(e => e.id == item.id)
            vue.items.data.splice(index, 1, item)
        },
        REMOVE_LINE: function(item, i){
            let vue = this
            if(typeof item.invoice_items != 'undefined'){
                item.invoice_items.splice(i, 1)
                let index = vue.items.data.findIndex(e => e.id == item.id)
                vue.items.data.splice(index, 1, item)
            }
        },
        CONFIRM: function (item) {
            let vue = this
            if(vue.confirm.filter(e => e == item.id).length == 0){
                vue.confirm.push(item.id)
                let data = {
                    package_id: item.id,
                    weight: item.weight,
                    user_id: item.user_id,
                    subtotal: item.subtotal,
                    shipping: item.shipping,
                    storage:item.storage,
                    agency: item.agency,
                    insurance: item.insurance,
                    handling:item.handling,
                    taxes: item.taxes,
                    tax_id: item.tax_id,
                    value: item.value,
                    delivery: item.delivery,
                    invoice_items: item['invoice_items'],
                }
                axios({url: '/thinning/packages/save', method: 'POST', data: data })
                .then((resp) => {
                    var audio = new Audio(soundSuccess)
                    audio.play()
                    vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    const routeData = vue.$router.resolve({name: 'PackageInvoice', params: { id: item.id }})
                    window.open(routeData.href, '_blank')

                    let index = vue.items.data.findIndex(e => e.id == item.id)
                    vue.items.data.splice(index, 1)

                    let remove = vue.confirm.findIndex(e => e == item.id)
                    vue.confirm.splice(remove, 1)
                    setTimeout(() => {
                        vue.$router.go()
                    }, 1000)
                })
                .catch((err) => {
                    var audio = new Audio(soundError)
                    audio.play()
                    if(err.response.status !== 422){
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.errors = err.response.data
                    }
                    let index = vue.confirm.findIndex(e => e == item.id)
                    vue.confirm.splice(index, 1)
                })
            }
        },
        GET_OPTIONS: function(e){
            this.options = e
        },
    },
    watch: {
        options: {
            handler() {
                if (this.cancelToken) {
                    this.cancelToken.cancel("Solicitud cancelada");
                }
                this.loading = 'table'
                this.INIT()
            },
            deep: true
        }
    }
}
</script>
